var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.86 6.432L10.197 1.83a1.907 1.907 0 00-2.394 0l-5.662 4.6a.84.84 0 00-.312.655v8.657c0 .465.38.848.844.848H6.47a.848.848 0 00.843-.848v-5.48h3.375v5.48c0 .465.378.848.843.848h3.797a.848.848 0 00.844-.848V7.086a.841.841 0 00-.312-.654zm-.533 9.316h-3.796V10.26a.841.841 0 00-.844-.84H7.313a.841.841 0 00-.844.84v5.488H2.673V7.086l5.663-4.6a1.059 1.059 0 011.33 0l5.662 4.6v8.662z",
    fill: "#879494"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconHome.6cd180d6.svg";
export { MemoForwardRef as ReactComponent };